import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Definizione } from '../../../../shared/interface';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-modifica-abbecedario-backoffice',
  templateUrl: './modifica-abbecedario-backoffice.component.html',
  styleUrl: './modifica-abbecedario-backoffice.component.css'
})
export class ModificaAbbecedarioBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private confirmationService: ConfirmationService) { }

  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;

  formDefinizione!: FormGroup;

  alfabeto: { lettera: string }[] = [
    { lettera: "A" },
    { lettera: "B" },
    { lettera: "C" },
    { lettera: "D" },
    { lettera: "E" },
    { lettera: "F" },
    { lettera: "G" },
    { lettera: "H" },
    { lettera: "I" },
    { lettera: "J" },
    { lettera: "K" },
    { lettera: "L" },
    { lettera: "M" },
    { lettera: "N" },
    { lettera: "O" },
    { lettera: "P" },
    { lettera: "Q" },
    { lettera: "R" },
    { lettera: "S" },
    { lettera: "T" },
    { lettera: "U" },
    { lettera: "V" },
    { lettera: "W" },
    { lettera: "X" },
    { lettera: "Y" },
    { lettera: "Z" },
  ]
  definizione?: Definizione;

  ngOnInit(): void {

    this.formDefinizione = new FormGroup({
      alfabeto: new FormControl(null, Validators.required),
      titolo: new FormControl(null, Validators.required),
      definizione: new FormControl(null, Validators.required)
    })

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getDefinizione(id).subscribe({
        next: (data) => this.definizione = data,
        error: (err) => this.router.navigate(['/backoffice/abbecedario']),
        complete: () => {

          this.formDefinizione.patchValue({
            alfabeto: { lettera: this.definizione?.alfabeto },
            titolo: this.definizione?.titolo,
            definizione: this.definizione?.definizione,
          })
        }
      })


    })
  }

  onDefinizione(e: any) {
    this.cdr.detectChanges();
  }

  onDeletePopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare la definizione?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteDefinizione(this.definizione!.id).subscribe({
          next: (data) => this.apiService.setDefinizioni(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/abbecedario']);
            this.apiService.message("success", "Eliminazione", "La definizione è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    let definizione = {
      alfabeto: this.formDefinizione.get('alfabeto')?.value.lettera,
      titolo: this.formDefinizione.get('titolo')?.value,
      definizione: this.formDefinizione.get('definizione')?.value
    }

    this.apiService.updateDefinizione(definizione, this.definizione!.id).subscribe({
      next: (data) => this.apiService.setDefinizioni(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/abbecedario'])
        this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
      }
    })

  }

}
